import styled from 'styled-components';
import { StatusMessageContainer } from "../StatusMessage/styles";
import { AccessContainer } from "../../containers/BookingAccessPass/styles";
import { InstructionsSection } from "../StepInstructions/styles";
import { AmenitiesContainer } from '../HotelAmenitiesSection/styles';
import { ButtonTag } from '../Button/styles';

export const NavigateToAccountContainer = styled.section`
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

export const NavigateToAccountHeading = styled.h2`
  margin: 0;
  margin-bottom: 25px;
  padding: 0;
  flex-basis: 100%;
  font-size: 22px;
  line-height: 1;

  @media (min-width: 768px) {
    margin-bottom: 35px;
    font-size: 24px;
  }
`;

export const MyAccountButton = styled(ButtonTag)`
  display: flex;
  height: 50px;
  padding: 10px 50px;
`;

export const NavigateToAccountText = styled.p`
  padding-right: 30px;
  color: ${({ theme }) => theme.green };

  @media (min-width: 1024px) {
    width: 70%;
  }
`;


export const BookingContainer = styled.main`
  flex-grow: 1;

  padding: 0 25px;
  padding-top: 30px;
  padding-bottom: 40px;

  @media (min-width: 768px) {
    padding: 0 40px;
    padding-top: 50px;
    padding-bottom: 80px;
  }
`;

export const BookingWrapper = styled.div`
  ${InstructionsSection} {
    margin-bottom: 20px;
    padding-bottom: 15px;

    border-bottom: 1px solid #f5f5f5;
  }

  ${StatusMessageContainer} {
    margin-bottom: 30px;
  }

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 315px;
    grid-template-rows: ${({ withUser }) => withUser ? '60px 115px 365px' : '60px 115px 285px 315px' };
    grid-auto-rows: max-content;
    grid-column-gap: 50px;
    align-items: flex-start;
    max-width: 1130px;
    margin: 0 auto;

    ${StatusMessageContainer} {
      grid-column: 1;
    }

    ${AccessContainer} {
      grid-column: 1;
    }

    ${NavigateToAccountContainer} {
      grid-column: 1;
    }
  }

  @media (min-width: 1024px) {
    grid-template-columns: 1.2fr 1fr 315px;
    grid-template-rows: ${({ withUser }) => withUser ? '70px 115px 195px 200px' : '70px 115px 195px 500px' };
    grid-column-gap: 50px;

    ${StatusMessageContainer} {
      grid-column: 1 / 3;
    }

    ${AccessContainer} {
      grid-column: 1 / 3;
    }

    ${NavigateToAccountContainer} {
      grid-column: 1 / 3;
    }

    ${InstructionsSection} {
      grid-column: 1 / 3;
    }
  }
`;

export const BookingTwoColumn = styled.div`
  grid-column: 1 / 3;
  margin-top: 50px;

  ${AmenitiesContainer} {
    padding: 0;
  }
`;

export const BookingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    grid-row: 1;
  }

  @media (min-width: 1024px) {
    grid-column: 1 / 3;
  }
`;

export const BookingHeading = styled.h1`
  margin: 0;
  padding: 0;

  font-size: 22px;
  line-height: 1;

  @media (min-width: 768px) {
    font-size: 36px;
  }
`;
